export default "__VITE_ASSET__72a75652__"